import {apiUrl} from '../common/Globals';
import {stringify} from 'query-string';
import {fileUploadBase64Payload} from '../common/Utils';
import {GET_LIST, GET_ONE, CREATE, UPDATE, DELETE, DELETE_MANY, GET_MANY} from 'react-admin';

import {HTTP_GET, HTTP_POST, HTTP_DELETE} from '../common/HttpService';

const resourceBaseUlr = apiUrl + '/notifications';
const base_url = 'http://localhost:8080/';
export const getNotification = async (params) => {
  const {id} = params;
  const url = `${resourceBaseUlr}/${id}`;
  let res = await HTTP_GET(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({
        message: typeof res.data === 'object' && res.data ? res.data.message || JSON.stringify(res.data) : res.data
      });
    });
  }
  if (res.data && typeof res.data === 'object') {
    res.data.notUrl = base_url + (res.data.notUrl || '');
  }
  return res;
};

const getManyNotifications = async (params) => {
  const query = {
    filter: JSON.stringify({id: params.ids})
  };
  const url = `${resourceBaseUlr}?${stringify(query)}`;

  let res = await HTTP_GET(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const getNotifications = async (params) => {
  const {page, perPage} = params.pagination;
  const {field, order} = params.sort;

  const query = {
    sort: JSON.stringify([field, order]),
    range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
    filter: JSON.stringify(params.filter)
  };
  const url = `${resourceBaseUlr}?${stringify(query)}`;

  let res = await HTTP_GET(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const createNotification = async (params) => {
  const url = `${resourceBaseUlr}`;
  let ImgUrl = '';
  if (params.data.images && params.data.images.title) {
    const imageUploadParams = {};
    const imagesss = await fileUploadBase64Payload([params.data.images], 'image');
    imageUploadParams.data = {};
    imageUploadParams.data.payloads = imagesss;
    imageUploadParams.data.resource = 'notification';
    imageUploadParams.data.resourceName = params.data.notName ? params.data.notName : '';
    imageUploadParams.data.id = 1;
    const url = apiUrl + '/upload';
    const body = imageUploadParams.data;
    let res = await HTTP_POST(url, body);
    if (res.success && res.data) {
      ImgUrl = res.data[0];
    }
  }
  params.data.notUrl = ImgUrl;
  const body = params.data;
  let res = await HTTP_POST(url, body);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const updateNotification = async (params) => {
  const {id} = params;
  const url = `${resourceBaseUlr}/${id}`;
  const body = params.data;
  let res = await HTTP_POST(url, body);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const deleteNotification = async (params) => {
  const {id} = params;
  const url = `${resourceBaseUlr}/${id}`;
  let res = await HTTP_DELETE(url);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const deleteMany = async (params) => {
  const url = `${resourceBaseUlr}`;
  const body = params;
  let res = await HTTP_DELETE(url, body);
  if (!res.success) {
    return new Promise(function (resolve, reject) {
      reject({message: res.data});
    });
  }
  return res;
};

const NotificationDataProvider = (type, resource, params) => {
  switch (type) {
    case GET_LIST:
      return getNotifications(params);

    case GET_MANY:
      return getManyNotifications(params);

    case GET_ONE:
      return getNotification(params);

    case CREATE:
      return createNotification(params);

    case UPDATE:
      return updateNotification(params);

    case DELETE:
      return deleteNotification(params);

    case DELETE_MANY:
      return deleteMany(params);

    default:
      return Promise.reject('Unknown Type');
  }
};

export default NotificationDataProvider;
